export const ScreenEnum = {
  profile: 'profile',
  report: 'report',
  organizationDetails: 'organizationDetails',
} as const;
